import gql from 'graphql-tag';

const query = gql`
  query CookbookFilterData {
    cookbook {
      tags {
        calorieRanges
        mealTypeTags {
          id
          name
        }
        dietTypeTags {
          id
          name
        }
        customTags {
          id
          name
        }
      }
      filterData {
        meals {
          id
          kcal
          preparationTime
          mealTypeTags
          dietTypeTags
          customTags
        }
      }
    }
  }
`;

export default query;
